<div class="flex h-dvh w-full overflow-hidden">
  <app-sidebar></app-sidebar>
  <div class="flex grow flex-col content-start overflow-hidden">
    <app-top-bar></app-top-bar>
    <div class="grow overflow-auto bg-slate-50">
      <router-outlet />
    </div>
  </div>
</div>
